import React from 'react';
import './WebLinkList.css';
import webLinkMap from '../../common/webLinkMap';
import SocialIcon from '../SocialIcons/SocialIcon';
import logComponent from '../../common/logComponent';

export default function WebLinkList({ links }) {
  if (logComponent('WebLinkList')) { console.debug('WebLinkList rendered'); }
  return (
    <ul className="Web-Link-List">
       {
        links != undefined &&
        links.map(link =>
          webLinkMap.has(link.type) &&
          <li className="Web-Link-List__link-item" key={link.type}>
            <SocialIcon style={{ height: '1.75rem', width: '1.75rem' }} type={link.type} link={link.url} />
          </li>
        )
      }
    </ul>
  );
}